export default "__VITE_ASSET__zxSJrDqp__"